import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Contact() {
  const initialFormData = {
    name: '',
    lastname: '',
    email: '',
    phone: '',
    subject: '',
    msg: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'First Name is required';
    if (!formData.lastname.trim()) newErrors.lastname = 'Last Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone Number is required';
    if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
    if (!formData.msg.trim()) newErrors.msg = 'Message is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSubmitStatus('error');
      return;
    }

    try {
      // Your fetch request to send the email
      // Assuming it is successful for demonstration purposes
      setSubmitStatus('success');
      setFormData(initialFormData); // Reset form data to initial empty values
      setErrors({});
    } catch (error) {
      console.error('Error:', error);
      setSubmitStatus('error');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  return (
    <div>
      <div className="breadcrumb-row">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                <div className="breadcrumb-title-heading">
                  <h1 className="title">Contact Us</h1>
                </div>
                <div className="breadcrumb-wrapper">
                  <span className="mr-1"><i className="ti ti-home"></i></span>
                  <Link title="Homepage" to="/">Home</Link>
                  <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                  <span className="ttm-textcolor-skincolor">Contact Us</span>
                </div>
              </div>
            </div>
          </div>  
        </div>                    
      </div>
      {/* <!-- Section Start --> */}
      <div className="section-padding">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-6">
              <div className="contact_box">
                <div className="icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <p className="text">13th Street. 47 W 13th St, New York, 10011, USA</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="contact_box">
                <div className="icon">
                  <i className="fas fa-phone"></i>
                </div>
                <Link to="tel:(+347)1234567890" className="text">(+347) 123 4567 890</Link>
                <p className="text">Mon-Sat 9:00am-5:00pm</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="contact_box">
                <div className="icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <Link to="mailto:example@example.com" className="text">example@example.com</Link>
                <p className="text">24 X 7 online support</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Section End --> */}
      {/* <!-- Contact Form Start --> */}
      <div className="section pt-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8">
              <div className="contact_form">
                <h4 className="title">Get In Touch</h4>
                {submitStatus === 'success' && (
                  <div className='success-message mb-3'>
                    Mail has been sent successfully!
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div className='error-message mb-3'>
                    Please fix the errors in the form and try again.
                  </div>
                )}
                <form onSubmit={handleSubmit} className="row form_style style_two">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className={`form-control form-control-custom ${errors.name && 'is-invalid'}`}
                          placeholder="First Name"
                          autoComplete="off"
                          required
                        />
                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="lastname"
                          value={formData.lastname}
                          onChange={handleChange}
                          className={`form-control form-control-custom ${errors.lastname && 'is-invalid'}`}
                          placeholder="Last Name"
                          autoComplete="off"
                          required
                        />
                        {errors.lastname && <div className="invalid-feedback">{errors.lastname}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`form-control form-control-custom ${errors.email && 'is-invalid'}`}
                          placeholder="Email"
                          autoComplete="off"
                          required
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className={`form-control form-control-custom ${errors.phone && 'is-invalid'}`}
                          placeholder="Phone No."
                          autoComplete="off"
                          required
                        />
                        {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          className={`form-control form-control-custom ${errors.subject && 'is-invalid'}`}
                          placeholder="Company Name"
                          autoComplete="off"
                          required
                        />
                        {errors.subject && <div className="invalid-feedback">{errors.subject}</div>}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <textarea
                          rows="8"
                          name="msg"
                          value={formData.msg}
                          onChange={handleChange}
                          className={`form-control form-control-custom ${errors.msg && 'is-invalid'}`}
                          placeholder="Message"
                          autoComplete="off"
                          required
                        ></textarea>
                        {errors.msg && <div className="invalid-feedback">{errors.msg}</div>}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <button type="submit" className="thm-btn btn-rectangle thm-bg-color-one w-100">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact_map">
                <div className="relative" id="map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1265800.300764836!2d95.26885152454206!3d21.810661510059965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x305652a7714e2907%3A0xba7b0ee41c622b11!2sMyanmar%20(Burma)!5e0!3m2!1sen!2sin!4v1705045723705!5m2!1sen!2sin"
                    width="100%"
                    height="500"
                    title="Google Map"
                  ></iframe>
                </div>
                <ul className="contact_social">
                  <li>
                    <Link to="#">
                      <i className="fab fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fa-brands fa-x-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-linkedin-in"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
